import styled, { css } from 'styled-components/macro'
import { ifProp, ifNotProp } from 'styled-tools'
import { em, rgba, color } from '../../../utils/styles'

const size = em(22)
const borderColor = ifProp('error',
  color('error'),
  ifProp('focused',
    color('base'),
    rgba('base', 0.4)
  )
)

const CheckboxIcon = styled.span`
  position: relative;
  display: inline-block;
  width: ${size};
  height: ${size};
  border: 2px solid ${borderColor};
  border-radius: 5px;

  ${ifNotProp('disabled', css`
    &:hover {
      border: 2px solid ${color('base')};
    }
  `)}

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    width: ${size};
    height: ${size};
    background-color: ${color('base')};
    border-radius: 5px;
    transform: ${ifProp('checked', 'scale(1, 1)', 'scale(0, 0)')};
    transition: transform 200ms ease-out;
    z-index: 1;
  }
`

export default CheckboxIcon
